module.exports = __webpack_public_path__ + "static/media/hall-PA.963a7fd5.svg";